module.exports = __webpack_public_path__ + "static/media/imagen6.d432adc1.jpg";